<div fxLayout="column" style="width: 100%;">
    <div *ngIf="hasFilter" class="pad-bottom-0">
        <form name="tableFilterPanelForm">
            <metadata-panel ngModelGroup="gridFilter" *ngIf="hasFilter" fxFlex="auto"
                            [metadata]="gridMetadata.FilterMetadata" [model]="filterModel"
                            [datacontroller]="filterDataController" (modifierCallback)="filterCallback($event)">
            </metadata-panel>
        </form>
    </div>

    <info-grid *ngIf="!loading" [rowsPerPage]="gridMetadata.RowsPerPage" [displayHeader]="displayHeader" [useRepository]="UseRepository"
               [noFilter]="viewMetadata.HideFilter" [metadataServerPaging]="serverPaging" [viewMetadata]="viewMetadata"
               [hideHeaderCheckbox]="hideHeaderCheckbox" [hideHeaderSelections]="hideHeaderSelections"
               [model]="model" [datacontroller]="datacontroller" [disableViewAction]="disableViewAction"
               (repositoryFunction)="doRepositoryFunction($event)" (onSelected)="onSelected($event)" [disableGridAdd]="disableGridAdd"
               [multipleEdit]="multipleEdit" style="height: 100%;" [parentView]="parentView" [isStepperGrid]="isStepperGrid">
    </info-grid>
</div>
